import { useState } from "react";
import constants from "../utilities/constants";

export const AccordionItem = ({ header, children, page }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {page === "checkout" ? (
        <div className="border-b border-gray-200 last:border-b-transparent w-full">
          <button
            className={`flex justify-between items-center w-full text-left text-xl font-tiemann text-[#222222] rounded-md font-bold focus:outline-none pr-4 ${
              isOpen ? "bg-white" : "bg-[#F3F3F3]"
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="flex items-center gap-3">
              <img src={constants.DEFAULT_IMAGE + "/giftmsg.svg"} />
              {header}
            </div>
            <span className="text-xl">
              {isOpen ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 17L12 7L2 17" stroke="black" strokeWidth="2" />
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 7L12 17L2 7" stroke="black" strokeWidth="2" />
                </svg>
              )}
            </span>
          </button>
          {isOpen && (
            <div className="px-0 text-white font-century font-medium text-sm">
              {children}
            </div>
          )}
        </div>
      ) : page === "footer" ? (
        <div className="border-b border-gray-200 last:border-b-transparent w-full">
          <button
            className="flex justify-between items-center w-full py-4 text-left text-lg text-white font-tiemann font-bold focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {header}
            <span className="text-xl">
              {isOpen ? (
                <img src={constants.DEFAULT_IMAGE + "/plus.svg"} />
              ) : (
                <img src={constants.DEFAULT_IMAGE + "/minus.svg"} />
              )}
            </span>
          </button>
          {isOpen && (
            <div className="px-4 text-white font-century font-medium text-sm">
              {children}
            </div>
          )}
        </div>
      )  : page === "details" ? (
        <div className="border-b border-[#C3E4E1] last:border-b-transparent w-full">
          <button
            className="flex justify-between items-center w-full py-4 text-left text-2xl font-normal text-[#242424] font-tiemann focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {header}
            <span className="text-xl">
              {isOpen ? (
                <img src={constants.DEFAULT_IMAGE + "/minus-g.svg"} />
              ) : (
                <img src={constants.DEFAULT_IMAGE + "/plus-g.svg"} />
              )}
            </span>
          </button>
          {isOpen && (
            <div className="px-4 text-black font-century font-medium text-sm">
              {children}
            </div>
          )}
        </div>
      ) : (

        <div className="border-b border-gray-200 last:border-b-transparent w-full">
        <button
          className={`flex justify-between items-center w-full text-left text-sm font-tiemann text-[#222222] rounded-md font-bold focus:outline-none pr-4 ${
            isOpen ? "bg-white" : "bg-[#F3F3F3]"
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex items-center">
            <img src={constants.DEFAULT_IMAGE + "/giftmsg.svg"} />
            {header}
          </div>
          <span className="text-xl">
            {isOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 17L12 7L2 17" stroke="black" strokeWidth="2" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 7L12 17L2 7" stroke="black" strokeWidth="2" />
              </svg>
            )}
          </span>
        </button>
        {isOpen && (
          <div className="px-0 text-white font-century font-medium text-sm">
            {children}
          </div>
        )}
      </div>
        
      )}
    </>
  );
};
